import React from 'react';
import BudgetAlloc from './Budget_Allocation';
import '../../../CommonCSS/SocietyCSS.css'

const BudgetAllocApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Budget Allocation</h5>
          </div>
        </div>
        <BudgetAlloc />
      </div>
    </div >
  );
};

export default BudgetAllocApp;
